import type { AidaConversationMedia } from './conversation-media'

const THUMB_LIMIT = 3

export interface ChatMediaPreview {
  thumbnailUrls: string[]
  mediaCount: number
}

export function chatMediaPreview(input: {
  list?: object
  items?: readonly AidaConversationMedia[]
  active?: boolean
}): ChatMediaPreview {
  const fromList = previewFromList(input.list)
  if (fromList.thumbnailUrls.length > 0 || fromList.mediaCount > 0) {
    return fromList
  }
  if (!input.active || !input.items) {
    return fromList
  }
  return previewFromMedia(input.items)
}

function previewFromList(source: object = {}): ChatMediaPreview {
  const fields = source as {
    thumbnailUrls?: readonly string[]
    thumbnail_urls?: readonly string[]
    mediaCount?: number
    media_count?: number
  }
  const rawUrls = fields.thumbnailUrls ?? fields.thumbnail_urls ?? []
  const thumbnailUrls = rawUrls.filter(url => url.length > 0).slice(0, THUMB_LIMIT)
  const rawCount = fields.mediaCount ?? fields.media_count
  const mediaCount = typeof rawCount === 'number' && rawCount > 0 ? rawCount : 0
  return { thumbnailUrls, mediaCount }
}

function previewFromMedia(items: readonly AidaConversationMedia[]): ChatMediaPreview {
  const ready = items.filter(item => item.status === 'ready')
  const thumbnailUrls = ready
    .flatMap(item => {
      const url = thumbUrl(item)
      return url ? [url] : []
    })
    .slice(0, THUMB_LIMIT)
  return { thumbnailUrls, mediaCount: ready.length }
}

function thumbUrl(item: AidaConversationMedia) {
  if (item.kind === 'video') {
    return item.posterUrl || item.thumbnailUrl || ''
  }
  if (item.kind === 'audio') {
    return item.thumbnailUrl || ''
  }
  return item.thumbnailUrl || item.url || ''
}
